// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

const isProduction = process.env.NEXT_PUBLIC_ENV === 'production';

function getSampleRate(defaultValue = 0) {
  const sentryClient: Record<string, unknown> = window.__ZL_SENTRY_FLAG;
  if (sentryClient) {
    const sampleRate = +sentryClient.sampleRate;
    if (sampleRate >= 0 && sampleRate <= 1) {
      return sampleRate;
    }
  }
  return defaultValue;
}

export function startClientSentry() {
  Sentry.init({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    environment: process.env.NEXT_PUBLIC_ENV,

    maxBreadcrumbs: 50,
    tracesSampleRate: 0,
    profilesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,

    debug: false,
    enabled: isProduction,
    sampleRate: 1,
    beforeSend: (event, hint) => {
      const sampleRate = getSampleRate();

      if (sampleRate > 0 && sampleRate <= 1) {
        return Math.random() < sampleRate ? event : null;
      }

      return null;
    },

    // 禁止浏览器未捕获异常、未处理 Promise rejection、XHR/事件回调异常自动上报。
    integrations: (defaultIntegrations) =>
      defaultIntegrations.filter((i) => !['GlobalHandlers', 'BrowserApiErrors'].includes(i.name)),
  });
}
